export default {
      id: "Icon--user-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--user",
      toString: function () {
        return this.url;
      }
    }